import React, { useState,useEffect  } from 'react';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { Box, Button, Dialog, Popover } from '@mui/material';
import { useParams } from 'react-router-dom';
import PageNotFound from '../PageNotFound';
import { useDispatch, useSelector } from 'react-redux';
import { usePanLookupApiMutation } from '../../features/panCard/panApi';
import CardSkeleton from '../../components/Skeleton/CardSkeleton';
import BoyIcon from '@mui/icons-material/Boy';
import GirlIcon from '@mui/icons-material/Girl';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import ModalWrapMain from '../../components/ModalWrapper/ModalWrapMain';
import CustomerInformation from '../Customer/CustomerInformation';
import LeadInformation from '../Customer/LeadInformation';
import DraggableDialog from '../../components/Dialog/DraggableDialog';
import DialogFirst from '../../components/Dialog/DialogFirst';
import useDisplayDate from '../../hooks/Date/useDisplayDate';


const PanLookup = () => {
      const { panno } = useParams();
const { formatDate } = useDisplayDate();
      const [getPanData, { data, error, isLoading }] = usePanLookupApiMutation();
      const [modelOpen, setModelOpen] = useState(false);

      // const handleModelOpen = (data) => setModelOpen(data);
      const handleModelOpen = (data) => {
  console.log(data,"dgcfhgjhkjl");
  setModelOpen(data);
};

      const handleModelClose = () => setModelOpen(null);


      useEffect(() => {
        getPanData({pancard : panno});  
      }, [panno, getPanData]);

      const [anchorEl, setAnchorEl] = useState(null);

      const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
      };
    
      const handlePopoverClose = () => {
        setAnchorEl(null);
      };
    
      const open = Boolean(anchorEl);


      const isValidPan = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panno);

        if (!isValidPan) {
          return (
            <PageNotFound 
            message={
              <>
                The PAN number you entered, 
                <span style={{color: 'red', fontWeight: 'bold'}}>{panno}</span>, 
                appears to be invalid. Double-check the details and enter a valid PAN number to proceed.
              </>
            } 
          />
          );        
        }


      
        
        // Show loading state
        if (isLoading) {
          return <CardSkeleton count={3} />;
        }
      
        // Show error if the API request fails
        if (error) {
          return <PageNotFound message={`Error: ${error.message}`} />;
        }
      
        // If no data found, show PageNotFound
        if (!data?.data) {
          return <PageNotFound message="No data found for the given PAN number" />;
        }
      
        console.warn(data,"dlfgsjhkjlefdg")
      return (
        <Box sx={{m: "10px",display: "flex",gap: 2}}>
          {data.data.map((item, index) => (
              <Card key={index} sx={{ width: 345 }}>
                <CardHeader
                  avatar={
                    <Avatar color="primary" sx={{ bgcolor: 'primary.main' }}  aria-label="recipe">
                        {item?.TAG}
                    </Avatar>
                  }
                  action={
                    <IconButton aria-label="settings">
                      <MoreVertIcon />
                    </IconButton>
                  }
                  title={item?.comp}
                  subheader={`Welcome ${item?.comp}`}
                />
                <CardContent sx={{pt: '0'}}>
                  <Box sx={{ display: 'flex',alignItems: "center"}}>
                           <Box  sx={{ display: 'inline',width: '50%' }}>Customer Info</Box>

                          
                          <Button className='LoraFont font-500' 
                          onClick={() => handleModelOpen({...item,modelname: "cusinfo"})} 
                          onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose}>

                                <OpenInFullIcon color='primary' sx={{mr: 1}} />
                               

                
                               <Box 
                                  sx={{
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                  }}
                                >
                                    {item?.name}  
                                </Box>
                          </Button>

                
                        <Popover
                          sx={{
                            pointerEvents: 'none',
                          }}
                          open={open}
                          anchorEl={anchorEl}
                          anchorOrigin={{
                            vertical: 'right',
                            horizontal: 'right',
                          }}
                          transformOrigin={{
                            vertical: 'right',
                            horizontal: 'left',
                          }}
                          onClose={handlePopoverClose}
                          disableRestoreFocus
                        >
                          <Typography color="primary" sx={{ p: 1,py: 0,display: "flex" }}>
                            {item?.gender === "Male" ? <BoyIcon />  : <GirlIcon />}

                            {item?.name}
                          </Typography>
                        </Popover>
                        
                  </Box>
                        
                  <Box sx={{display: 'flex',alignItems: "center"}}>
                           <Box  sx={{width: '35%' }}>Lead Details</Box>
                                   <Button className='LoraFont font-500'  onClick={() => handleModelOpen({...item,modelname: "leadinfo"})} >
                                        <RemoveRedEyeIcon color='primary' sx={{mr: 1}}/> 
                                        View More
                                   </Button>
                           
                  </Box>


                  <Box sx={{display: 'flex'}}>
                           <Box  sx={{width: '60%' }}>repay date ⮚ </Box> <Box className='LoraFont font-500' > {formatDate(item?.latestCase?.repayDate)} </Box>
                           
                           
                  </Box>
                  <Box sx={{display: 'flex'}}>
                           <Box  sx={{width: '60%' }}>Loan Amt ⮚ </Box> <Box className='LoraFont font-500' > {item?.latestCase?.loanAmtApproved} </Box> 
                  </Box>    
                  <Box sx={{display: 'flex'}}>
                           <Box  sx={{width: '60%' }}>Remark ⮚ </Box> <Box className='LoraFont font-500' > {item?.latestCase?.collectionremarks} </Box> 
                  </Box> 
                  <Box sx={{display: 'flex'}}>
                           <Box  sx={{width: '60%' }}>Status ⮚ </Box> <Box className='LoraFont font-500' > {item?.latestCase?.approvalstatus} </Box> 
                  </Box>
                  <Box sx={{display: 'flex'}}>
                           <Box  sx={{width: '60%' }}>Loan No. ⮚ </Box> <Box className='LoraFont font-500' > {item?.latestCase?.loanNo} </Box> 
                  </Box>
                  <Box sx={{display: 'flex'}}>
                           <Box  sx={{width: '60%' }}>Disbursal Amount ⮚ </Box> <Box className='LoraFont font-500' > {item?.latestCase?.disbursalAmount} </Box> 
                  </Box>
                  <Box sx={{display: 'flex'}}>
                           <Box  sx={{width: '60%' }}>Disbursal Date ⮚ </Box> <Box className='LoraFont font-500' > {formatDate(item?.latestCase?.disbursalDate)} </Box> 
                  </Box>
                  <Box sx={{display: 'flex'}}>
                           <Box  sx={{width: '60%' }}>Disbursal Time ⮚ </Box> <Box className='LoraFont font-500' > {item?.latestCase?.disbursalTime} </Box> 
                  </Box>
                  <Box sx={{display: 'flex'}}>
                           <Box  sx={{width: '60%' }}>Disbursal Ref ⮚ </Box> <Box className='LoraFont font-500' > {formatDate(item?.latestCase?.disbursalRefrenceNo)} </Box> 
                  </Box>
                  {/* <Box sx={{display: 'flex',width: "100%",alignItems: "center"}}>
                           <Box  sx={{ display: 'inline',width: '49%' }}>Disbusted Date</Box>
                           <Box sx={{display: 'flex'}} className='LoraFont font-500' >
                                <CalendarMonthIcon 
                                sx={{
                                  color: 'primary.main',
                                }}/> 
                                <span> 24 April 2025</span>
                           </Box>
                  </Box>
                              
                  <Box sx={{display: 'flex',width: "100%"}}>
                           <Box  sx={{ display: 'inline',width: '49%' }}>Repay Amount</Box>
                           <Box sx={{display: 'flex'}} className='LoraFont font-500' >
                                <CurrencyRupeeIcon 
                                sx={{
                                  color: '#DAA520',
                                  filter: 'drop-shadow(0 0 4px rgba(218, 165, 32, 0.7))',
                                }}/> 
                                <span> 1000</span>
                           </Box>
                  </Box>
                              
                  <Box sx={{display: 'flex',width: "100%"}}>
                           <Box  sx={{ display: 'inline',width: '49%' }}>Repay Date</Box>
                           <Box sx={{display: 'flex'}} className='LoraFont font-500' >
                                <CalendarMonthIcon 
                                sx={{
                                  color: 'primary.main',
                                }}/> 
                                <span> 24 April 2025</span>
                           </Box>
                  </Box> */}
                              
                              
                </CardContent>
                              
              </Card>
          ))}




                            <ModalWrapMain
                                 open={modelOpen?.modelname === "cusinfo"}
                                 onClose={handleModelClose}
                                 title="Customer Information"
                                 width={{ xs: '90%', sm: '90%', md: "600px", lg: "600px" }}
                            >
                                  
                                   <CustomerInformation custdata={modelOpen}/>
                            </ModalWrapMain>


                            {/* <ModalWrapMain
                                 open={modelOpen?.modelname === "leadinfo"}
                                 onClose={handleModelClose}
                                 title="Lead Information"
                                 width={{ xs: '90%', sm: '90%', md: "600px", lg: "600px" }}
                            > */}
                                 <DialogFirst
                                   open={modelOpen?.modelname === "leadinfo"}
                                   onClose={handleModelClose}
                                   title="Lead Detail"
                                   dialogWidth="md"
                                 >
                                                    <LeadInformation custdata={modelOpen}/>
                                   </DialogFirst>
                            {/* </ModalWrapMain> */}

                            
        </Box>
      );
}
    


export default PanLookup;
